module.exports = __webpack_public_path__ + "img/mobile3.cb8f3135.svg";